// src/componentsdash/Modulos/Historia Clinica/ConsultaSeguimiento/CuestionarioPorEspecialidadConsulta.js
import React from "react";
import Accordion from "../Accordion";
import { CATALOGO_CONSULTA, ESPECIALIDADES, PREGUNTAS_NOM24_GENERALES, PREGUNTAS_NOM24_GERONTOLOGIA, PREGUNTAS_NOM24_SALUD_MATERNA, PREGUNTAS_NOM24_PEDIATRIA  } from "../../../../services/cuestionariocatalog";
import { variableAplica  } from "../../../../utils/validaciones/elegibilidad";

export default function CuestionarioPorEspecialidadConsulta({
  especialidadMedico,   // "ginecologia" | "pediatria" | "geriatria" | null
  consulta,             // state de ConsultaSeguimiento
  setConsulta,
  openRubros,
  toggleRubro,
  selectedKeys,         // Set<string> | null (respetar [] => Set vacío)
  nom024 = false,
  edadPaciente,
  edadMesesPaciente,
  sexo,
  fechaNacimiento,
}) {
  // Normaliza array → name/type (switch para boolean), igual que en Historia
  const mapQuestions = (arr = []) =>
    (arr || []).map((q) => ({
      ...q,
      name: q.name || q.key,
      type: q.type || (q.tipo === "boolean" ? "switch" : q.tipo),
       labels: q.labels || null,
    }));

  // Todas las preguntas de la especialidad activa (modo seed/fallback)
  const preguntasDeActiva = mapQuestions(CATALOGO_CONSULTA[especialidadMedico] || []);

  // Todas las preguntas de todas las especialidades (para mezcla en selected_keys)
  const preguntasDeTodas = ESPECIALIDADES.flatMap((esp) =>
    mapQuestions(CATALOGO_CONSULTA[esp] || [])
  );

  // Reglas:
  // - Si selectedKeys !== null => usar exactamente esas claves (aunque esté vacío)
  // - Si selectedKeys == null => usar preguntasDeActiva (fallback por especialidad)
  const preguntas = selectedKeys
    ? preguntasDeTodas.filter((q) => selectedKeys.has(q.name))
    : preguntasDeActiva;

  // [1] Gateo por switches (solo pintar; no toca Config)
  const preguntasFiltradas = (Array.isArray(preguntas) ? preguntas : []).filter((q) => {
    if (q.name === "longitud" && !consulta?.es_longitud) return false;
    if (q.name === "detalle_caidas_12_meses" && !consulta?.caidas_ultimos_12_meses) return false;
    return true;
  });
  
  // =========================
  // PREGUNTAS NOM (SEPARADAS)
  // =========================
   
  const preguntasNOMGenerales = mapQuestions(PREGUNTAS_NOM24_GENERALES);

  const preguntasNOMGerontologia = mapQuestions(PREGUNTAS_NOM24_GERONTOLOGIA)
    .filter((q) => variableAplica(q.name, { edad: edadPaciente }));

  const preguntasNOMSaludMaterna = mapQuestions(PREGUNTAS_NOM24_SALUD_MATERNA)
  .filter((q) =>
    variableAplica(q.name, {
      edad: edadPaciente,
      sexo,
      relacionTemporalEmbarazo: consulta?.relacionTemporalEmbarazo,
      puerpera: consulta?.puerpera,
      atencionPregestacionalRT: consulta?.atencionPregestacionalRT,
    })
  );
  
  const preguntasNOMPediatria = mapQuestions(PREGUNTAS_NOM24_PEDIATRIA)
  .filter((q) =>
    variableAplica(q.name, {
      edad: edadPaciente,
      edadMeses: edadMesesPaciente,
      fecha_nacimiento: fechaNacimiento,
      ninoSanoRT: consulta?.ninoSanoRT,
      pruebaEDI: consulta?.pruebaEDI,
      edasRT: consulta?.edasRT,
      edasPlanTratamiento: consulta?.edasPlanTratamiento,
      irasRT: consulta?.irasRT
    })
  );

  const madreSeleccionada =
    consulta?.atencionPregestacionalRT ? "pregestacion" :
    consulta?.relacionTemporalEmbarazo ? "embarazo" :
    consulta?.puerpera ? "puerperio" :
    null;

  const preguntasMaternasFiltradas = preguntasNOMSaludMaterna.filter((q) => {
    if (!madreSeleccionada) return true;

    if (q.name === "atencionPregestacionalRT") return madreSeleccionada === "pregestacion";
    if (q.name === "relacionTemporalEmbarazo") return madreSeleccionada === "embarazo";
    if (q.name === "puerpera") return madreSeleccionada === "puerperio";

    return true;
  });
  // [2] Guard clause si no queda nada visible y aqui activa o desactiva dependiendo switch nom(consistente con Historia)
 const hayNOM = nom024 && (
    preguntasNOMGenerales.length > 0 ||
    preguntasNOMGerontologia.length > 0 ||
    preguntasMaternasFiltradas.length > 0 ||
    preguntasNOMPediatria.length > 0
  );

  if (preguntasFiltradas.length === 0 && !hayNOM) return null;
  const handleChange = (name, value) => {

  // ------------------------------------------------------------
  // LIMPIEZA PEDIATRÍA
  // ------------------------------------------------------------
  if (name === "ninoSanoRT") {
    setConsulta((prev) => ({
      ...prev,
      ninoSanoRT: value,
      pruebaEDI: "",
      resultadoEDI: "",
      edasRT: "",
      edasPlanTratamiento: "",
      recuperadoDeshidratacion: "",
      irasRT: "",
      irasPlanTratamiento: "",
      neumoniaRT: ""
    }));
    return;
  }

  // ------------------------------------------------------------
  // LIMPIEZA GINECOLOGÍA
  // ------------------------------------------------------------
  if (
    name === "atencionPregestacionalRT" ||
    name === "relacionTemporalEmbarazo" ||
    name === "puerpera"
  ) {
    setConsulta((prev) => ({
      ...prev,
      [name]: value,
      riesgo: "",
      trimestreGestacional: "",
      primeraVezAltoRiesgo: "",
      complicacionPorDiabetes: "",
      complicacionPorInfeccionUrinaria: "",
      complicacionPorPreeclampsiaEclampsia: "",
      complicacionPorHemorragia: "",
      hipertensionarterialprexistente: "",
      otrasAccPrescAcidoFolico: "",
      otrasACCApoyoTransladoAME: "",
      infeccionPuerperal: ""
    }));
    return;
  }

    setConsulta((prev) => ({ ...prev, [name]: value }));
  };

  const renderInput = (q) => {
    const value = consulta[q.name] ?? "";

    if (q.type === "textarea") {
      return (
        <textarea
          id={q.name}
          value={value}
          placeholder={q.placeholder || ""}
          maxLength={q.maxLength ?? undefined}
          onChange={(e) => handleChange(q.name, e.target.value)}
        />
      );
    }

    if (q.type === "switch") {
      return (
        <label className="switch">
          <input
            type="checkbox"
            id={q.name}
            checked={!!value}
            onChange={(e) => handleChange(q.name, e.target.checked)}
          />
          <span className="switch__slider" />
        </label>
      );
    }

    if (q.type === "select") {
  let options = q.options && q.options.length ? q.options : [];

  // Filtrado de opciones según otra pregunta (opcionesPorDependencia)
  if (q.opcionesPorDependencia) {
    const { dependeDe, mapa } = q.opcionesPorDependencia;
    const valorPadre = consulta?.[dependeDe];
    options = mapa[valorPadre] || [];
  }

      return (
        <select
          id={q.name}
          value={value}
          onChange={(e) => handleChange(q.name, e.target.value)}
        >
          <option value="">Seleccione…</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
               {q.labels?.[opt] || opt}
            </option>
          ))}
        </select>
      );
    }

        // DESPUÉS
    if (q.type === "multiselect") {
      const seleccionados = Array.isArray(value) ? value : (value ? String(value).split("&").map(Number) : []);
      return (
        <div>
          {q.options.map((opt) => (
            <label key={opt} style={{ display: "block", marginBottom: 4 }}>
              <input
                type="checkbox"
                checked={seleccionados.includes(opt)}
                onChange={(e) => {
                  let nuevos;
                  if (opt === 9) {
                    nuevos = e.target.checked ? [9] : [];
                  } else {
                    if (e.target.checked) {
                      nuevos = [...seleccionados.filter(v => v !== 9), opt];
                    } else {
                      nuevos = seleccionados.filter(v => v !== opt);
                    }
                  }
                  handleChange(q.name, nuevos.length ? nuevos.join("&") : "");
                }}
              />
              {" "}{q.labels?.[opt] || opt}
            </label>
          ))}
        </div>
      );
    }
    // text / number / date
    return (
      <input
        type={q.type}
        step={q.step}
        id={q.name}
        value={value}
        placeholder={q.placeholder || ""}
        maxLength={q.type === "text" ? q.maxLength ?? undefined : undefined}
        onChange={(e) => handleChange(q.name, e.target.value)}
      />
    );
  };

  return (
     <Accordion
    title="Cuestionario específico por especialidad"
    isOpen={openRubros["rubro-cuestionario-especialidad-consulta"]}
    onToggle={() => toggleRubro("rubro-cuestionario-especialidad-consulta")}
    anchorId="rubro-cuestionario-especialidad-consulta"
  >
    <div className="rubro">
        {/* PREGUNTAS NOM */}
    {nom024 && preguntasNOMGenerales.length > 0 && (
        <>
          <div className="subrubro">
            <h3>Promoción de la salud</h3>
          </div>

          {preguntasNOMGenerales.map((q) => (
            <div key={`general-${q.name}`} className="subrubro">
              <label htmlFor={q.name}>{q.label}</label>
              {renderInput(q)}
            </div>
          ))}
        </>
      )}

    {nom024 && preguntasNOMGerontologia.length > 0 && (
      <>
        <div className="subrubro">
          <h3>Intervención Gerontológica</h3>
          <p>Escoge si se realizó para alguno</p>
        </div>

        {preguntasNOMGerontologia.map((q) => (
          <div key={`nom-${q.name}`} className="subrubro">
            <label htmlFor={q.name}>{q.label}</label>
            {renderInput(q)}
          </div>
        ))}
      </>
    )}

    {nom024 && preguntasMaternasFiltradas.length > 0 && (
      <>
        <div className="subrubro">
          <h3>Intervención en Salud Materna</h3>
          <p>Escoge si se realizó para alguno</p>
        </div>

        {preguntasMaternasFiltradas.map((q) => (
          <div key={`materna-${q.name}`} className="subrubro">
            <label htmlFor={q.name}>{q.label}</label>
            {renderInput(q)}
          </div>
        ))}
      </>
    )}

    {nom024 && preguntasNOMPediatria.length > 0 && (
    <>
      <div className="subrubro">
        <h3>Intervención Pediátrica</h3>
        <p>Escoge si se realizó para alguno</p>
      </div>

      {preguntasNOMPediatria.map((q) => (
        <div key={`pediatria-${q.name}`} className="subrubro">
          <label htmlFor={q.name}>{q.label}</label>
          {renderInput(q)}
        </div>
      ))}
    </>
  )}

    {preguntasFiltradas.map((q) => (
        <div key={q.name} className="subrubro">
          <label htmlFor={q.name}>{q.label}</label>
          {renderInput(q)}
        </div>
      ))}
    </div>
  </Accordion>  
  );
}
